import * as React from "react";
import {translate} from "react-i18next";
import {connect} from "react-redux";

import {
    ITranslatedComponent,
    ITypefamilyMap
} from "../../redux/reducers/generalReducer";

import ColumnFactory from "../../services/ColumnFactory";
import deepEqual from 'deep-equal';
import {
    ModelyearDto,
    TypefamilyDto,
    CnrDto,
    ResourceListOfModelyearDto
} from "../../services/Client";
import {compose} from "redux";
import {
    selectUserCnrs,
    selectUserPSLModelyears,
    selectUserTypefamiliesMap
} from "../../redux/selectors";
import {isDefinedPSLSelection} from "../../utils/GeneralUtils";
import {IPSLSel, IPslSelection} from "./PSL/PslSelect";
import {IReduxState} from "src/redux/IReduxState";

export let currentLinkName: string;

interface IMapStateToProps {
    userTypefamiliesMap: ITypefamilyMap;
    userPSLModelyears: ResourceListOfModelyearDto;
    userCnrs: CnrDto[];

}

interface ILinkNameProps {
    value: string;
    redirectToPSL(psl?: IPslSelection): void;
    prefix?: string;
}

interface ILinkNameTProps extends ITranslatedComponent, ILinkNameProps, IMapStateToProps {
}

interface LinkData {
    modelyear?: string;
    typefamily?: string;
    cnr?: string;
}
interface IILinkNameState {
    link: LinkData;
}

class LinkNameT extends React.Component<ILinkNameTProps, IILinkNameState> {
    node: HTMLSelectElement | null = null;
    constructor(props: ILinkNameTProps) {
        super(props);
        this.getLinkData = this.getLinkData.bind(this);
        const link = this.getLinkData(props);
        this.state = {
            link
        };
    }

    componentWillReceiveProps(newProps: ILinkNameProps) {
        const link = this.getLinkData(newProps);
        if (!deepEqual(link, this.state.link)) {
            this.setState({link});
        }
    }

    getLinkData(props: ILinkNameProps) {
        const [modelyear, typefamily, cnr] = props.value.split('/');
        return {
            modelyear,
            typefamily,
            cnr
        };
    }

    render() {
        const {link} = this.state;
        const pslTemp = LinkNameT.decodeLink(link, this.props);
        const text = LinkNameT.getLinkDescription(this.props.prefix ? this.props.prefix : "PSL", this.props, this.props.t, pslTemp);
        currentLinkName = text;
        return (
            <div>
                <h5 style={{whiteSpace: 'nowrap'}}>
                    {text}
                </h5>
            </div>
        );
    }

    public static decodeLink(link: LinkData, props: IMapStateToProps) {
        const {userTypefamiliesMap, userPSLModelyears, userCnrs = []} = props;
        const {modelyear, typefamily, cnr} = link;

        const modelyearId = modelyear ? parseInt(modelyear, 10) : NaN;
        const typefamilyId = typefamily ? parseInt(typefamily, 10) : NaN;
        const cnrId = cnr ? parseInt(cnr, 10) : NaN;

        const mj = userPSLModelyears.elements ? userPSLModelyears.elements.find((m: ModelyearDto) => m.objectId === modelyearId) : undefined;

        const typefamilyRes = mj ? userTypefamiliesMap[mj.mj1] : undefined;
        const typefamilies = !typefamilyRes || !typefamilyRes.elements ? [] : typefamilyRes.elements;

        const tf = typefamilies.find((t: TypefamilyDto) => t.objectId === typefamilyId);
        const cn = userCnrs.find((c: CnrDto) => c.objectId === cnrId);
        let searchParams;
        // @ts-ignore
        if (props && props.history) {
            // @ts-ignore
            searchParams = new URLSearchParams(props.history.location.search);
        }

        return {modelyear: mj, typefamily: tf, cnr: cn, isNewTable: searchParams ? searchParams.get('isNewTable') : false};
    }

    public static getLinkDescription(prefix: string, state: IMapStateToProps, t: reactI18Next.TranslationFunction, pslTemp?: IPSLSel) {
        let p = {
            modelyear: '?',
            typefamily: '?',
            cnr: '?'
        };

        if (isDefinedPSLSelection(pslTemp)) {
            const psl = pslTemp as IPslSelection;
            p = {
                modelyear: ColumnFactory.mj2str(psl.modelyear),
                typefamily: psl.typefamily.name,
                cnr: t(`GLOBAL:${psl.cnr.cnr}`)
            };
        }
        const linkDescription = t(prefix + "_WITH_PARAMS", p);
        return linkDescription;
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userTypefamiliesMap: selectUserTypefamiliesMap(state),
    userPSLModelyears: selectUserPSLModelyears(state),
    userCnrs: selectUserCnrs(state)
});

const LinkNameConnected = compose<React.ComponentType<any>>(
    translate("OPTIONS_VIEW"),
    connect<IMapStateToProps>(mapStateToProps)
)(LinkNameT);

class LinkName extends React.Component<ILinkNameProps> {
    public static decodeLink = LinkNameT.decodeLink;
    public static getLinkDescription = LinkNameT.getLinkDescription;

    render() {
        return <LinkNameConnected {...this.props} />;
    }
}
export default LinkName;



// WEBPACK FOOTER //
// ./src/views/OptionsView/LinkName.tsx